import { ReactNode } from 'react'

import { HorizontalScrollArea } from '@marketplace-web/shared/horizontal-scroll-area'

type Props = {
  children: ReactNode
  className: string
}

const ScrollableContentBody = ({ children, className }: Props) => {
  return (
    <HorizontalScrollArea controlsScrollType={HorizontalScrollArea.ControlScrollType.Partial}>
      <div className={className}>{children}</div>
    </HorizontalScrollArea>
  )
}

export default ScrollableContentBody
